import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Interceptor function to add `withCredentials` flag to HTTP requests for specified secure URLs.
 * The interceptor is build on a "allowList" approach, meaning that only URLs that are in the secureUrls array
 * will have the `withCredentials` flag set to true.
 * This prevents the credentials from being sent to other domains by accident.
 *
 * @param {string[]} [secureUrls=[]] - An array of URL prefixes that require credentials.
 * @returns {HttpInterceptorFn} - A function that intercepts HTTP requests and adds the `withCredentials` flag if the request URL matches any of the secure URLs.
 */
export const withCredentialsInterceptor =
  (secureUrls: string[] = []): HttpInterceptorFn =>
  (req, next) => {
    if (secureUrls.some(url => req.url.startsWith(url))) {
      const clonedRequest = req.clone({ withCredentials: true });
      return next(clonedRequest);
    }

    return next(req);
  };
